<div class="subscriber-header">
  <h3>{{ getUsername(stream.connection.data) }}</h3>
  <button type="button" title="Switch en fullscreen" (click)="switchFullscreen()" [disabled]="screenSharingInProcess$ | async"></button>
</div>
<div #visioSubscriberContainer class="subscriber-content">
  <cng-visio-toggle-actions *ngIf="!!stream" [stream]="stream"></cng-visio-toggle-actions>
</div>
